export function vues( ){
	new Vue({
		el: '#app',
		data: {
			contact: false
		}
	});
}